import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getProducts } from '../api';
import { useFavorites } from '../context/FavoritesContext';
import { useAuth } from '../context/AuthContext';
import ProductCard from '../components/ProductCard';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CartSidebar from '../components/CartSidebar';
import LoginModal from '../components/LoginModal';
import { Button } from '../components/ui/button';
import { Loader2 } from 'lucide-react';

const FavoritesPage = () => {
  const { favorites } = useFavorites();
  const { user, setIsLoginModalOpen } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProducts();
  }, [favorites]);

  const loadProducts = async () => {
    if (!favorites || favorites.length === 0) {
      setProducts([]);
      setLoading(false);
      return;
    }
    
    try {
      const allProducts = await getProducts();
      const favoriteProducts = allProducts.filter(p => favorites.includes(p.id));
      setProducts(favoriteProducts);
    } catch (error) {
      console.error('Failed to load products:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-brand-surface dark:bg-[#1E1E1E] transition-colors">
        <Header />
        <LoginModal />
        <main className="pt-24 pb-24">
          <div className="max-w-[1920px] mx-auto px-4 md:px-8 lg:px-12">
            <div className="text-center py-16">
              <h1 className="text-2xl font-medium mb-4 text-brand-text dark:text-brand-text">Избранное</h1>
              <p className="text-brand-text dark:text-brand-text mb-6">Войдите, чтобы просматривать избранные товары</p>
              <Button
                onClick={() => setIsLoginModalOpen(true)}
                className="bg-brand-accent dark:bg-brand-accent text-brand-text dark:text-brand-text hover:bg-brand-surface dark:hover:bg-brand-surface"
              >
                Войти
              </Button>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-brand-surface dark:bg-[#1E1E1E] transition-colors">
      <Header />
      <CartSidebar />
      <LoginModal />

      <main className="pt-20 md:pt-24 pb-24">
        <div className="max-w-[1920px] mx-auto px-4 md:px-8 lg:px-12">
          <h1 className="text-2xl md:text-3xl font-medium mb-8 text-brand-text dark:text-brand-text">Избранное</h1>

          {loading ? (
            <div className="flex justify-center py-16">
              <Loader2 className="w-8 h-8 animate-spin text-brand-text" />
            </div>
          ) : products.length === 0 ? (
            <div className="text-center py-16">
              <p className="text-brand-text dark:text-brand-text mb-6">У вас пока нет избранных товаров</p>
              <Link to="/">
                <Button className="bg-brand-accent dark:bg-brand-accent text-brand-text dark:text-brand-text hover:bg-brand-surface dark:hover:bg-brand-surface">
                  Перейти к товарам
                </Button>
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
              {products.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FavoritesPage;
